export const defaultWarning = 'Ooops, it looks like you are using an unsupported web browser. For a better experience, please use a modern web browser';
